import React from 'react';
import { TimkenUnit } from '../../components/bearing-search/types/types';
import { handleActionError } from '../utils/engineering-tools';

export type ClearanceCalculationsState = {
	unit: TimkenUnit;
};

export const initialClearanceCalculationsState: ClearanceCalculationsState = {
	unit: 'M',
};

export type ClearanceCalculationsAction =
	| { type: 'change_unit'; payload: TimkenUnit }
	| { type: 'reset'; payload?: ClearanceCalculationsState };

const clearanceCalculationsReducer: React.Reducer<
	ClearanceCalculationsState,
	ClearanceCalculationsAction
> = ( state, action ) => {
	switch ( action.type ) {
		case 'change_unit': {
			return {
				...state,
				unit: action.payload,
			};
		}
		case 'reset': {
			const newState = action.payload ? action.payload : initialClearanceCalculationsState;

			return {
				...newState,
			};
		}
	}

	return handleActionError( action );
};

export default clearanceCalculationsReducer;
